import { render, staticRenderFns } from "./CustomLogs.vue?vue&type=template&id=5927a3de&scoped=true"
import script from "./CustomLogs.vue?vue&type=script&lang=js"
export * from "./CustomLogs.vue?vue&type=script&lang=js"
import style0 from "./CustomLogs.vue?vue&type=style&index=0&id=5927a3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927a3de",
  null
  
)

export default component.exports